import { createAsyncThunk } from '@reduxjs/toolkit';
import { IFilterObj } from 'src/components/filters';
import { FormField2, IDynamicFormValue, toFormFields2 } from 'src/lib';
import { fetchLocalFilters } from '../../planner_v2/api/planner-api';
import getLocalFiltersPayload from '../../planner_v2/utils/utils';
import {
  fetchAsIsGridData,
  fetchAsIsGridDataV2,
  fetchColorGradientForGrid,
  fetchToBeGridData,
  fetchToBeGridDataV2
} from '../api/simulation-summary-api';

export const getGridDataForAsAndToBe = createAsyncThunk(
  '/api/summary/getGridDataForAsAndToBe',
  async ({
    sourceId,
    scenarioId,
    moduleId,
    localFilterFormFields,
    filters,
    localFilterFormValue
  }: {
    sourceId: number;
    scenarioId: number;
    moduleId: number;
    filters: IFilterObj[];
    localFilterFormValue: IDynamicFormValue;
    localFilterFormFields: FormField2[];
  }) => {
    const localFilters = getLocalFiltersPayload(
      localFilterFormValue,
      localFilterFormFields
    );
    const colorGradientResponse = await fetchColorGradientForGrid(
      moduleId,
      sourceId,
      scenarioId,
      filters,
      localFilters
    );
    const toBeResponse = await fetchToBeGridData(
      moduleId,
      sourceId,
      scenarioId,
      filters,
      localFilters
    );
    const asIsResponse = await fetchAsIsGridData(
      moduleId,
      sourceId,
      scenarioId,
      filters,
      localFilters
    );
    return {
      colorGradient: colorGradientResponse.data,
      asIs: asIsResponse.data,
      toBe: toBeResponse.data
    };
  }
);

export const getGridDataForAsAndToBeV2 = createAsyncThunk(
  '/api/summary/getGridDataForAsAndToBeV2',
  async ({
    sourceId,
    scenarioId,
    moduleId,
    plannerModuleId,
    localFilterFormFields,
    filters,
    localFilterFormValue,
    currency_toggle
  }: {
    sourceId: number;
    scenarioId: number;
    moduleId: number;
    plannerModuleId: number;
    filters: IFilterObj[];
    localFilterFormValue: IDynamicFormValue;
    localFilterFormFields: FormField2[];
    currency_toggle: boolean;
  }) => {
    const localFilters = getLocalFiltersPayload(
      localFilterFormValue,
      localFilterFormFields
    );
    const asIsResponse = await fetchAsIsGridDataV2(
      plannerModuleId,
      sourceId,
      scenarioId,
      filters,
      localFilters,
      currency_toggle
    );
    const toBeResponse = await fetchToBeGridDataV2(
      moduleId,
      sourceId,
      scenarioId,
      filters,
      localFilters,
      currency_toggle
    );
    return {
      colorGradient: toBeResponse.data['gradient-metric-metadata'],
      asIs: asIsResponse.data,
      toBe: toBeResponse.data
    };
  }
);

export const getLocalFiltersData = createAsyncThunk(
  'getLocalFiltersData',
  async (args: {
    sourceID: number;
    scenarioId: number;
    filters: IFilterObj[];
  }) => {
    const response = await fetchLocalFilters(
      args.sourceID,
      args.scenarioId,
      args.filters
    );
    const fields = toFormFields2(response.localFilter);
    const values = fields.reduce<IDynamicFormValue>(
      (prev, curr) => ({ ...prev, [curr.name]: curr.default_value }),
      {}
    );
    return { values, fields };
  }
);
